import React, { FunctionComponent, useCallback, useEffect } from 'react';
import { Translate, useTranslate } from '@pegasus/translation';
import { MessageDialog, Size } from '@lux/dialog';
import { Discounts as DiscountsGraphic } from '@lux/graphics';
import { removeQueryParam } from '@browsing/utils';

import { trackSelectContent, trackViewContent } from '@browsing/tracking';
import { ExpiredCampaignDialogProps, CampaignExpiredStatus } from './types';

const getTrackingElement = (status: CampaignExpiredStatus) =>
    status === CampaignExpiredStatus.NOT_FOUND
        ? 'nonexistent_campaign_banner'
        : 'expired_campaign_banner';

const getDialogTitle = (status: CampaignExpiredStatus) =>
    status === CampaignExpiredStatus.NOT_FOUND
        ? 'expiredCampaign.notFoundTitle'
        : 'expiredCampaign.expiredCampaignTitle';

const ExpiredCampaignDialog: FunctionComponent<ExpiredCampaignDialogProps> = ({
    show,
    showStatus,
    onClose,
}) => {
    const translate = useTranslate();
    const trackingElement = getTrackingElement(showStatus);
    const dialogTitle = getDialogTitle(showStatus);

    const handleClose = useCallback(
        (isCtaButton = false) => {
            const contentType = isCtaButton ? 'discover_here' : 'close';
            // TODO: type will be added to module after qa https://jira.zalando.net/browse/LACT-454
            // @ts-expect-error type will be added to module after qa
            trackSelectContent(trackingElement, contentType);
            removeQueryParam(['event', 'status']);
            onClose();
        },
        [onClose, trackingElement],
    );

    const handleCloseDialog = useCallback(() => handleClose(), [handleClose]);
    const handlePositiveButtonClick = useCallback(() => handleClose(true), [handleClose]);

    useEffect(() => {
        if (show) {
            // TODO: type will be added to module after qa https://jira.zalando.net/browse/LACT-454
            // @ts-expect-error type will be added to module after qa
            trackViewContent(trackingElement, 'view');
        }
    }, [show, trackingElement]);

    return (
        <MessageDialog
            size={Size.S}
            isShown={show}
            closeLabel={translate('expiredCampaign.close')}
            closeDialog={handleCloseDialog}
            graphic={<DiscountsGraphic />}
            title={<Translate message={dialogTitle} />}
            text={<Translate message="expiredCampaign.subText" />}
            positiveButtonText={<Translate message="expiredCampaign.buttonText" />}
            positiveButtonProps={{ onClick: handlePositiveButtonClick }}
        />
    );
};

export default ExpiredCampaignDialog;
